export default function ContactUsPage() {
  return (
    <div className="mx-auto max-w-5xl min-h-screen">
      <div className="my-10">
        <h2 className="text-4xl font-bold text-black-900 mb-4">
          ExpenseHut LLC
        </h2>
        <h3>551S I-35 STE 300 PMB 504</h3>
        <h3>Round Rock, TX 78664</h3>

        <div className="mt-6 divAlignItemsOnly">
          <div className="mx-2">help@expensehut.com</div>
        </div>

        <div className="mt-4 divAlignItemsOnly">
          <div className="mx-2"> +1 818 561 1139</div>
        </div>
      </div>
    </div>
  );
}
